import * as React from 'react';
import { connect } from 'react-redux';
import isNil from 'lodash/isNil';

import Page from 'components/page/Page';

import CampaignsDashboardMixed from '../../components/campaigns-mixed/campaigns-dashboard/CampaignsDashboardMixed';
import CampaignsInfluencerDashboard from '../../components/campaign-influencer-dashboard/CampaignsInfluencerDashboard';

import { __t, applyTranslations } from 'utils/language';
import { isBrandsFocusedOrganization, isInfluencersFocusedOrganization } from 'utils/organization';

applyTranslations(require('./campaigns-page-mixed.i18n.json'));

import type {
  Organization,
  OrganizationMapById
} from 'types';

type OwnProps = {
  params: {
    id: string
  }
};

type StateProps = {
  organizationsMapById: OrganizationMapById,
  isCcmEnabled: boolean
};

type Props = OwnProps & StateProps;

const MSG_KEY = 'campaigns_page_mixed';

const CampaignsPageMixed: React.FC<Props> = ({
  params,
  organizationsMapById,
  isCcmEnabled
}): JSX.Element => {
  const organization = organizationsMapById[Number(params.id)];
  const isBrandOrganization = !isNil(organization) && isBrandsFocusedOrganization(organization);
  const isInfluencerOrganization = !isNil(organization) && isInfluencersFocusedOrganization(organization);

  const getBrandStatus = (
    flag: boolean,
    org: Organization
  ): boolean => (
    flag && org?.ccmStatus !== 'only'
  );

  const getCcmStatus = (
    flag: boolean,
    org: Organization
  ): boolean => {
    const brandHasCcm = org?.ccmStatus === 'enabled'
      || org?.ccmStatus === 'only';

    return flag && brandHasCcm;
  };

  const shouldRenderBrandsCampaigns = getBrandStatus(isBrandOrganization, organization);
  const shouldRenderCcmCampaigns = getCcmStatus(isCcmEnabled, organization);

  return (
    <Page documentTitle={__t(`${MSG_KEY}.title`)}>
      <div className="campaigns-page-mixed">
        {
          (shouldRenderBrandsCampaigns || shouldRenderCcmCampaigns) && (
            <CampaignsDashboardMixed
              key={`campaigns-page-mixed-${organization.id}`}
              shouldRenderBrandsCampaigns={shouldRenderBrandsCampaigns}
              shouldRenderCcmCampaigns={shouldRenderCcmCampaigns}
              organization={organization}
            />
          )
        }
        {
          isInfluencerOrganization && (
            <CampaignsInfluencerDashboard
              key={`campaigns-influencers-dashboard-${organization.id}`}
              organization={organization}
            />
          )
        }
      </div>
    </Page>
  );
};

const mapStateToProps = ({
  organizations,
  runtimeConfig
}): StateProps => ({
  organizationsMapById: organizations.mapByOrganizationId,
  isCcmEnabled: runtimeConfig.config.isCcmEnabled ?? false
});

export default connect(mapStateToProps)(CampaignsPageMixed);
